import React from "react";

type CaretProps = {
  color?: string;
  direction?: "left" | "right" | "up" | "down";
};

const Caret: React.FC<CaretProps> = ({
  color = "#000",
  direction = "left",
}) => {
  const getRotation = () => {
    switch (direction) {
      case "right":
        return "rotate(180, 12, 12)"; // 180° around the center
      case "up":
        return "rotate(90, 12, 12)"; // 90° clockwise
      case "down":
        return "rotate(-90, 12, 12)"; // 90° counterclockwise
      default: // "left"
        return "";
    }
  };

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 6L9 12L15 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform={getRotation()}
      />
    </svg>
  );
};

export default Caret;
